export const menu = `absolute top-3 right-3 flex gap-x-2 items-center justify-end`;
export const attribution = `flex items-center gap-3 p-3 bg-base-white font-medium tracking-wider justify-end`;
